import { GRAPHQL_API_URLS } from '../config/constants';
import getEnvFromHostname from './getEnvFromHostname';

const getGraphqlUrl = (): string => {
  const env: string = getEnvFromHostname();
  return GRAPHQL_API_URLS[env] ?? GRAPHQL_API_URLS['ue1dev1'];
};

export default getGraphqlUrl;
